(() => {
  if (window.PerleniMega) return;
  const root = window.Shopify?.routes?.root || '/';
  const giftId = 10926495629651;
  const campaignProductIds = new Set([10776997626195,10777520210259,10777523749203,10777527648595,10777530892627,10873778274643,10873786237267,10873816482131,10872249450835,10872251154771,10872260788563,10872476696915,10872477778259,10873912623443,10878887985491,10878908432723,11025038213459,11025038246227]);
  const giftCode = 'EROEFFNUNGSPROBE';
  const campaignEnd = Date.parse('2026-11-16T00:00:00+01:00');
  const active = () => Date.now() < campaignEnd;
  let serial = Promise.resolve();
  let checkoutBusy = false;
  let giftCardBusy = false;
  async function request(path, body) {
    const response = await fetch(root + path, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Der Warenkorb konnte nicht aktualisiert werden. Bitte versuche es erneut.');
    return data;
  }
  const isGift = item => item.product_id === giftId;
  function syncSampleCards(cart) {
    if (!Array.isArray(cart?.items)) return;
    const hasGift = true;
    const setCount = cart.items.filter(item => Number(item.product_id) === 10998236512595).reduce((n, item) => n + item.quantity, 0);
    const giftCount = cart.items.filter(isGift).reduce((n, item) => n + item.quantity, 0);
    let copy = '5 Duftproben für 9,99 € inkl. Standardversand nach Österreich und Deutschland. Gratisversand ab 45 € und ein Gratis-Geschenk ab 50 € Warenwert nach Rabatten.';
    if (giftCount) copy = 'Die Einzelproben-Aktion ist beendet. Bitte entferne die Aktionsprobe aus dem Warenkorb.';
    else if (setCount && cart.item_count === setCount) copy = '5 Duftproben für 9,99 € pro Set – Versand inklusive. Kostenloser Standardversand nach Österreich und Deutschland. Keine zusätzlichen Aktionsrabatte auf das Set.';
    else if (setCount) copy = 'Der Versand deines Kennenlernsets ist inklusive. Für weitere Artikel gelten die regulären Versandkosten; die endgültigen Kosten siehst du im Checkout.';
    document.querySelectorAll('[data-perleni-cart-offer]').forEach(box => {
      const paragraph = box.querySelector('p');
      if (paragraph) { paragraph.textContent = copy; paragraph.setAttribute('role', giftCount && cart.item_count !== 1 ? 'alert' : 'status'); }
      const button = box.querySelector('button');
      if (button) button.hidden = Boolean(setCount || giftCount);
    });
    document.querySelectorAll('[data-perleni-sample-card]').forEach(card => {
      const free = card.querySelector('[data-perleni-free-sample]');
      const paid = card.querySelector('[data-perleni-paid-sample]');
      if (free) free.hidden = hasGift;
      if (paid) paid.hidden = !hasGift;
    });
  }
  function refreshSampleCards() {
    if (!document.querySelector('[data-perleni-sample-card], [data-perleni-cart-offer]')) return;
    request('cart.js').then(syncSampleCards).catch(() => {});
  }
  function enqueue(task) {
    const result = serial.then(task);
    serial = result.catch(() => {});
    return result;
  }
  function checkoutCodes(cart) {
    const excluded = new Set(['EROEFFNUNG30', 'PERLENI-MEGA30', giftCode, 'PERLENIPROBE', 'PERLENI-MEGAPROBE', 'GRATISPROBE']);
    const codes = (cart.discount_codes || [])
      .map(code => typeof code === 'string' ? code : code.code)
      .filter(code => code && !excluded.has(code.toUpperCase()));
    return [...new Set(codes)];
  }
  function checkoutUrl(cart) {
    const url = new URL(root + 'checkout', location.origin);
    const codes = checkoutCodes(cart);
    if (codes.length) url.searchParams.set('discount', codes.join(','));
    return url.href;
  }
  async function apply(sections = []) {
    let cart = await request('cart.js');
    const shippingLabel = item => [10777530892627, 10872249450835].includes(Number(item.product_id)) ? 'In Kürze verfügbar' : 'Sofort lieferbar';
    const oldNotes = cart.items.filter(item => item.properties?.Vorbestellung || item.properties?.Versand !== shippingLabel(item));
    for (const item of oldNotes) {
      const properties = { ...item.properties };
      delete properties.Vorbestellung;
      properties.Versand = shippingLabel(item);
      cart = await request('cart/change.js', { id: item.key, quantity: item.quantity, properties });
    }
    const codes = checkoutCodes(cart);
    cart = await request('cart/update.js', {
      discount: [...new Set(codes)].join(','), sections: sections.slice(0, 5), sections_url: location.pathname
    });
    syncSampleCards(cart);
    return cart;
  }
  const ensure = sections => enqueue(() => apply(sections));
  async function addGift() { throw new Error('Die Einzelproben-Aktion ist beendet. Entdecke unser 5er-Kennenlernset.'); }
  async function addSet(variantId, sections) {
    return enqueue(async () => {
      const before = await request('cart.js');
      if (before.items.some(isGift)) throw new Error('Die Gratisproben-Aktion ist beendet. Bitte entferne die Aktionsprobe aus dem Warenkorb.');
      if (!before.items.some(item => Number(item.variant_id) === variantId)) {
        await request('cart/add.js', { items: [{ id: variantId, quantity: 1, properties: { Versand: 'Sofort lieferbar' } }] });
      }
      return apply(sections);
    });
  }
  window.PerleniMega = { ensure, addGift, addSet, active, request };
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-perleni-add-gift]');
    if (!button) return;
    event.preventDefault();
    if (giftCardBusy || button.disabled) return;
    giftCardBusy = true;
    const card = button.closest('[data-perleni-sample-card]');
    const status = card.querySelector('[data-perleni-sample-status]');
    const label = button.querySelector('span');
    const original = label.textContent;
    const buttons = [...document.querySelectorAll('[data-perleni-add-gift]')];
    buttons.forEach(item => { item.disabled = true; });
    status.hidden = true;
    label.textContent = button.dataset.loadingLabel;
    button.setAttribute('aria-busy', 'true');
    try {
      const cartUI = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const sections = cartUI ? cartUI.getSectionsToRender().map(section => section.id) : ['cart-icon-bubble'];
      cartUI?.setActiveElement(button);
      const variantId = Number(button.dataset.perleniAddGift);
      const cart = await addGift(variantId, sections);
      const line = cart.items.find(item => item.variant_id === variantId && isGift(item));
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'perleni-sample-card', cartData: cart });
      }
      if (cartUI) {
        cartUI.classList.remove('is-empty');
        cartUI.renderContents({ ...line, sections: cart.sections });
      } else {
        location.assign(root + 'cart');
      }
    } catch (error) {
      status.textContent = error.message;
      status.hidden = false;
      refreshSampleCards();
    } finally {
      label.textContent = original;
      button.removeAttribute('aria-busy');
      buttons.forEach(item => { item.disabled = false; });
      giftCardBusy = false;
    }
  });
  async function checkout(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutBusy) return;
    checkoutBusy = true;
    try {
      const cart = await ensure([]);
      const gifts = cart.items.filter(isGift);
      if (gifts.length) throw new Error('Die Einzelproben-Aktion ist beendet. Bitte entferne die Aktionsprobe aus dem Warenkorb.');
      if (active() && cart.items.some(item => campaignProductIds.has(Number(item.product_id)) && !item.parent_relationship && item.final_line_price > Math.round(item.original_line_price * 0.8))) {
        throw new Error('Der Aktionsrabatt konnte noch nicht bestätigt werden. Bitte aktualisiere den Warenkorb und versuche es erneut.');
      }
      location.assign(checkoutUrl(cart));
    } catch (error) {
      checkoutBusy = false;
      window.alert(error.message);
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('a[href],button[name="checkout"],input[name="checkout"]');
    if (!button) return;
    const href = button.getAttribute('href');
    if (button.name === 'checkout' || (href && new URL(href, location.href).pathname.replace(/\/$/, '').endsWith('/checkout'))) checkout(event);
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout' || new URL(event.target.action || location.href, location.href).pathname.replace(/\/$/, '').endsWith('/checkout')) checkout(event);
  }, true);

  function startCountdown() {
    const timer = document.querySelector('[data-perleni-countdown]');
    if (!timer) return;
    function tick() {
      const remaining = Math.max(0, Math.floor((campaignEnd - Date.now()) / 1000));
      if (remaining === 0) {
        document.querySelectorAll('[data-perleni-campaign], .perleni-opening').forEach(element => { element.hidden = true; });
        clearInterval(interval);
        return;
      }
      const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
      Object.entries(values).forEach(([unit, value]) => {
        const element = timer.querySelector('[data-countdown-' + unit + ']');
        if (element) element.textContent = String(value).padStart(2, '0');
      });
    }
    const interval = setInterval(tick, 1000);
    tick();
  }
  function start() {
    startCountdown();
    refreshSampleCards();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshSampleCards);
    }
    document.addEventListener('shopify:section:load', refreshSampleCards);
    window.addEventListener('pageshow', refreshSampleCards);
    if (location.pathname.replace(/\/$/, '').endsWith('/cart')) {
      const entries = ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'].map(id => {
        const element = document.getElementById(id);
        return { id, section: element?.dataset.id || id, element };
      });
      ensure(entries.map(entry => entry.section)).then(cart => {
        for (const entry of entries) {
          const html = cart.sections?.[entry.section];
          if (!html) continue;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const fresh = parsed.getElementById(entry.id);
          if (entry.element && fresh) entry.element.innerHTML = fresh.innerHTML;
          else if (entry.element && parsed.querySelector('.shopify-section')) entry.element.innerHTML = parsed.querySelector('.shopify-section').innerHTML;
        }
      }).catch(error => {
        const message = document.getElementById('cart-errors');
        if (message) message.textContent = error.message;
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();


